export enum LoginError {
  UNAUTHORIZED = 'Invalid username/password combination',
  INCORRECT = 'Incorrect username or password.',
  PASSWORD_ATTEMPTS = 'Password attempts exceeded',
  BAD_REQUEST = 'Missing required credentials',
  NO_PERSON = 'Cannot find Person',
  NO_AVAILABLE_USERS_BASED_ON_DOMAIN = 'Cannot find any users for this domain. Please check URL',
  MS_USER_NOT_FOUND_WITH_CODE = 'Microsoft user not found with code',
  MS_USER_EMAIL_NOT_FOUND_IN_NINETY = 'Microsoft user email not found in Ninety',
  // Kept in sync with the backend's LoginError.MS_TOKEN_EXCHANGE_FAILED copy.
  MS_TOKEN_EXCHANGE_FAILED = 'We could not complete your Microsoft sign-in. Please try again.',
  LOGIN_METHOD_NOT_ALLOWED = 'Your company requires single sign-on. Please sign in using one of the single sign-on options.',

  // Cognito exception-name-driven messages (see cognito-error-mapping.ts).
  PASSWORD_RESET_REQUIRED = 'Your password needs to be reset. Please use "Forgot password" to set a new one.',
  RATE_LIMITED = 'Too many attempts. Please wait a few minutes and try again.',
  UNCONFIRMED = 'Please confirm your account before signing in.',
  MISCONFIGURED = 'We hit a configuration issue signing you in. Please contact support.',
  CONNECTION_TIMEOUT = 'We could not reach the sign-in service. Check your connection and try again.',
}
